import firebase from 'firebase';
import 'firebase/firestore';

firebase.initializeApp({
	apiKey: 'AIzaSyBDXFbL07I2cTzGqnIziVUrvjgdru0L5bU',
	authDomain: 'invoices-c4ea5.firebaseapp.com',
	databaseURL: 'https://invoices-c4ea5.firebaseio.com',
	projectId: 'invoices-c4ea5',
	storageBucket: '',
	messagingSenderId: '67359475115'
});

const db = firebase.firestore();

db.settings({
	timestampsInSnapshots: true
});

export { db };
export const auth = firebase.auth();



// WEBPACK FOOTER //
// ./src/services/firebase.js